import { CLIENT_LOGOS } from "@/lib/site-data";

export const LogoMarquee = () => {
  const items = [...CLIENT_LOGOS, ...CLIENT_LOGOS];
  return (
    <section
      data-testid="logo-marquee"
      className="bg-white border-y border-slate-200 py-10"
    >
      <div className="container-narrow flex items-baseline justify-between mb-8">
        <div className="overline text-slate-500">
          Trusted by operators & boards across Europe
        </div>
        <div className="hidden md:block overline text-slate-400">
          A selection of recent engagements
        </div>
      </div>
      <div className="relative overflow-hidden">
        <div
          className="flex gap-16 whitespace-nowrap animate-marquee"
          style={{ width: "max-content" }}
        >
          {items.map((name, i) => (
            <span
              key={i}
              className="font-serif text-2xl md:text-3xl text-slate-400 tracking-tight"
            >
              {name}
            </span>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent" />
      </div>
    </section>
  );
};

export default LogoMarquee;
